import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mathNotation',
})
export class MathNotationPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    switch (value) {
      case 'le':
        return '≤';
      case 'lt':
        return '<';
      case 'ge':
        return '≥';
      case 'gt':
        return '>';
      default:
        return '';
    }
  }
}
